import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { DEBUG_BUILD } from '../debug-build.js';
import { SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT, SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE } from '../semanticAttributes.js';
import { debug } from '../utils/debug-logger.js';
import { getActiveSpan, getRootSpan } from '../utils/spanUtils.js';

/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */
function setMeasurement(name, value, unit) {
  var activeSpan = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : getActiveSpan();
  var rootSpan = activeSpan && getRootSpan(activeSpan);
  if (rootSpan) {
    DEBUG_BUILD && debug.log("[Measurement] Setting measurement on root span: ".concat(name, " = ").concat(value, " ").concat(unit));
    rootSpan.addEvent(name, _defineProperty(_defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE, value), SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT, unit));
  }
}

/**
 * Convert timed events to measurements.
 */
function timedEventsToMeasurements(events) {
  if (!events || events.length === 0) {
    return undefined;
  }
  var measurements = {};
  events.forEach(function (event) {
    var attributes = event.attributes || {};
    var unit = attributes[SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
    var value = attributes[SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
    if (typeof unit === 'string' && typeof value === 'number') {
      measurements[event.name] = {
        value: value,
        unit: unit
      };
    }
  });
  return measurements;
}
export { setMeasurement, timedEventsToMeasurements };